import { Button } from "@/components/ui/atoms/Button/Button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/atoms/Dialog/Dialog";
import { Textarea } from "@/components/ui/atoms/Textarea/Textarea";
import { useState } from "react";

type AdminSettingsCommunicateEditEmailSignatureProps = {
  value: string;
  onSubmit: (value: string) => void;
}

const AdminSettingsCommunicateEditEmailSignature = ({ value, onSubmit }: AdminSettingsCommunicateEditEmailSignatureProps) => {
  const [signature, setSignature] = useState<string>(value);
  const [open, setOpen] = useState(false);

  const onSave = (signature: string): void => {
    onSubmit(signature);
    setOpen(false);
  }

  const onCancel = (): void => {
    setSignature(value);
    setOpen(false);
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="w-fit">Personnaliser</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Signature</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2w">
          Cliquez sur le texte pour éditer la signature de l`utilisateur.
          <Textarea value={signature} onChange={(e) => setSignature(e.target.value)}></Textarea>
        </div>
        <DialogFooter>
          <div className="flex flex-row gap-2w justify-center">
            <Button variant='secondary' onClick={onCancel}>Annuler</Button>
            <Button onClick={() => onSave(signature)}>Valider</Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>)
}

export default AdminSettingsCommunicateEditEmailSignature;